(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.querySelector('[data-compare-wrapper]');
        this.slider = this.querySelector('[data-compare-slider]');
        if (!this.wrapper || !this.slider) return;

        this.hasAnimated = false;
        this.isAnimating = false;
        this.onInput = this.onInput.bind(this);
        this.onIntersection = this.onIntersection.bind(this);

        this.slider.addEventListener('input', this.onInput);
        this.slider.addEventListener('pointerdown', this.onInput);
        this.sync();
        this.setupHint();
      }

      disconnectedCallback() {
        if (this.slider) {
          this.slider.removeEventListener('input', this.onInput);
          this.slider.removeEventListener('pointerdown', this.onInput);
        }

        if (this.observer) this.observer.disconnect();
      }

      onInput() {
        if (this.isAnimating) return;
        this.sync();
      }

      sync() {
        const value = this.slider.value;
        this.style.setProperty('--compare', value);
        this.slider.setAttribute('aria-valuenow', value);
      }

      setupHint() {
        if (!window.IntersectionObserver) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.observer = new IntersectionObserver(this.onIntersection, {
          threshold: 0.45,
        });
        this.observer.observe(this.wrapper);
      }

      onIntersection(entries) {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || this.hasAnimated) return;
          this.hasAnimated = true;
          this.animateHint();
          if (this.observer) this.observer.disconnect();
        });
      }

      animateHint() {
        const start = Number(this.slider.value);
        const left = Math.max(0, start - 10);
        const right = Math.min(100, start + 10);

        this.isAnimating = true;
        this.style.setProperty('--before-after-transition', '0.5s');

        window.setTimeout(() => {
          this.style.setProperty('--compare', String(left));
        }, 100);

        window.setTimeout(() => {
          this.style.setProperty('--compare', String(right));
        }, 600);

        window.setTimeout(() => {
          this.style.setProperty('--compare', String(start));
        }, 1100);

        window.setTimeout(() => {
          this.style.setProperty('--before-after-transition', '0s');
          this.slider.value = String(start);
          this.isAnimating = false;
          this.sync();
        }, 1600);
      }
    }

    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-history"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-history-media')) {
    class BrandHistoryMedia extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-brand-history-sound]');
        if (!this.button) return;

        this.soundOn = false;
        this.onToggle = this.onToggle.bind(this);
        this.onResize = this.onResize.bind(this);
        this.button.addEventListener('click', this.onToggle);
        window.addEventListener('resize', this.onResize);
        this.applySound();
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onToggle);
        window.removeEventListener('resize', this.onResize);
      }

      get videos() {
        return Array.from(this.querySelectorAll('video'));
      }

      getVisibleVideo() {
        return this.videos.find((video) => window.getComputedStyle(video).display !== 'none') || this.videos[0] || null;
      }

      onToggle() {
        this.soundOn = !this.soundOn;
        this.applySound();
      }

      onResize() {
        this.applySound();
      }

      applySound() {
        const visible = this.getVisibleVideo();

        this.videos.forEach((video) => {
          video.muted = true;
        });

        if (this.soundOn && visible) {
          visible.muted = false;
          const playPromise = visible.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              visible.muted = true;
              this.soundOn = false;
              this.syncButton();
            });
          }
        }

        this.syncButton();
      }

      syncButton() {
        if (!this.button) return;

        this.classList.toggle('is-unmuted', this.soundOn);
        this.button.setAttribute('aria-pressed', this.soundOn ? 'true' : 'false');
        const playLabel = this.button.getAttribute('data-label-play') || 'Play sound';
        const muteLabel = this.button.getAttribute('data-label-mute') || 'Mute sound';
        this.button.setAttribute('aria-label', this.soundOn ? muteLabel : playLabel);
      }
    }

    customElements.define('brand-history-media', BrandHistoryMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-icons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-icons')) {
    class FeatureIcons extends HTMLElement {
      connectedCallback() {
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-feature-icon-card]');
        if (!item || !this.contains(item)) return;

        this.querySelectorAll('[data-feature-icon-card]').forEach((card) => {
          card.classList.toggle('is-selected', card === item);
        });
      }

      onBlockDeselect(event) {
        const item = event.target.closest('[data-feature-icon-card]');
        if (!item || !this.contains(item)) return;
        item.classList.remove('is-selected');
      }
    }

    customElements.define('feature-icons', FeatureIcons);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('materials-grid')) {
    class MaterialsGrid extends HTMLElement {
      connectedCallback() {
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onMqChange = this.syncCarouselRole.bind(this);

        this.mq = window.matchMedia('(max-width: 749px)');
        this.syncCarouselRole();

        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', this.onMqChange);
        } else {
          this.mq.addListener(this.onMqChange);
        }

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        if (this.mq) {
          if (this.mq.removeEventListener) {
            this.mq.removeEventListener('change', this.onMqChange);
          } else {
            this.mq.removeListener(this.onMqChange);
          }
        }

        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      isMobileCarousel() {
        return this.classList.contains('materials--mobile-carousel') && this.mq && this.mq.matches;
      }

      syncCarouselRole() {
        if (!this.classList.contains('materials--mobile-carousel')) return;

        if (this.mq && this.mq.matches) {
          this.setAttribute('aria-roledescription', 'carousel');
        } else {
          this.removeAttribute('aria-roledescription');
        }
      }

      scrollCardIntoView(item) {
        const grid = this.querySelector('.materials__grid');
        if (!grid || !this.isMobileCarousel()) return;

        const paddingStart = parseFloat(window.getComputedStyle(grid).paddingInlineStart) || 0;
        grid.scrollTo({
          left: item.offsetLeft - paddingStart,
          behavior: 'smooth',
        });
      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-materials-card]');
        if (!item || !this.contains(item)) return;

        this.querySelectorAll('[data-materials-card]').forEach((card) => {
          card.classList.toggle('is-selected', card === item);
        });
        this.scrollCardIntoView(item);
      }

      onBlockDeselect(event) {
        const item = event.target.closest('[data-materials-card]');
        if (!item || !this.contains(item)) return;
        item.classList.remove('is-selected');
      }
    }

    customElements.define('materials-grid', MaterialsGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menswear-featured-collection"] && !Shopify.designMode) return;
  try {
    
  /* MARCA | 11 September 2026 | Custom element for drag-to-scroll and keyboard navigation on the carousel */
  if (!customElements.get('menswear-featured-carousel')) {
    class MenswearFeaturedCarousel extends HTMLElement {
      constructor() {
        super();
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
      }

      connectedCallback() {
        this.dragging = false;
        this.moved = false;
        this.dragStartX = 0;
        this.dragStartScroll = 0;
        this.scrollTimer = null;

        this.addEventListener('pointerdown', this.onPointerDown.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      get items() {
        return Array.from(this.querySelectorAll('.menswear-featured-collection__item'));
      }

      scrollToItem(index, smooth = true) {
        const item = this.items[index];
        if (!item) return;
        this.scrollTo({
          left: item.offsetLeft - this.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto',
        });
      }

      onPointerDown(event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        // MARCA | 14 September 2026 | Do not capture pointer on the quick-view icon or other controls; capture retargets the click and the modal never opens
        if (event.target.closest('a, button, input, label, [data-menswear-quick-atc-trigger]')) return;

        this.dragging = true;
        this.moved = false;
        this.dragStartX = event.clientX;
        this.dragStartScroll = this.scrollLeft;
        this.classList.add('is-dragging');
        this.setPointerCapture(event.pointerId);
        this.addEventListener('pointermove', this.onPointerMove);
        this.addEventListener('pointerup', this.onPointerUp);
        this.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const delta = event.clientX - this.dragStartX;
        if (Math.abs(delta) > 4) this.moved = true;
        this.scrollLeft = this.dragStartScroll - delta;
      }

      onPointerUp() {
        this.dragging = false;
        this.classList.remove('is-dragging');
        this.removeEventListener('pointermove', this.onPointerMove);
        this.removeEventListener('pointerup', this.onPointerUp);
        this.removeEventListener('pointercancel', this.onPointerUp);
        window.setTimeout(() => { this.moved = false; }, 50);
      }

      onClick(event) {
        if (this.moved) {
          event.preventDefault();
          event.stopPropagation();
        }
      }

      onKeydown(event) {
        const items = this.items;
        if (!items.length) return;

        const scrollPos = this.scrollLeft;
        const viewWidth = this.clientWidth;

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          const next = items.find(
            (item) => item.offsetLeft - this.offsetLeft > scrollPos + 10
          );
          if (next) {
            this.scrollTo({
              left: next.offsetLeft - this.offsetLeft,
              behavior: 'smooth',
            });
          }
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          const reversed = [...items].reverse();
          const prev = reversed.find(
            (item) => item.offsetLeft - this.offsetLeft < scrollPos - 10
          );
          if (prev) {
            this.scrollTo({
              left: prev.offsetLeft - this.offsetLeft,
              behavior: 'smooth',
            });
          } else {
            this.scrollTo({ left: 0, behavior: 'smooth' });
          }
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (event.key === 'End') {
          event.preventDefault();
          this.scrollTo({
            left: this.scrollWidth - viewWidth,
            behavior: 'smooth',
          });
        }
      }
    }

    customElements.define('menswear-featured-carousel', MenswearFeaturedCarousel);
  }

  /* MARCA | 11 September 2026 | Desktop scrollbar stays in a standalone binder so theme hot-reload still wires it */
  function bindMenswearFeaturedScrollbar(scroller) {
    if (scroller.dataset.mfcScrollbarReady === 'true') return;

    const parent = scroller.parentElement;
    const scrollbar = parent ? parent.querySelector('[data-mfc-scrollbar]') : null;
    const thumb = scrollbar ? scrollbar.querySelector('[data-mfc-scrollbar-thumb]') : null;
    if (!scrollbar || !thumb) return;

    scroller.dataset.mfcScrollbarReady = 'true';

    let dragging = false;
    let dragStartX = 0;
    let dragStartScroll = 0;
    let scrollRaf = null;

    const maxScrollOf = () => Math.max(0, scroller.scrollWidth - scroller.clientWidth);

    const update = () => {
      const maxScroll = maxScrollOf();
      if (maxScroll < 1) {
        scrollbar.classList.remove('is-visible');
        return;
      }

      scrollbar.classList.add('is-visible');

      const trackWidth = scrollbar.clientWidth;
      if (trackWidth < 1) return;

      const thumbWidth = Math.max(48, (scroller.clientWidth / scroller.scrollWidth) * trackWidth);
      const maxThumb = Math.max(0, trackWidth - thumbWidth);
      const thumbLeft = maxThumb > 0 ? (scroller.scrollLeft / maxScroll) * maxThumb : 0;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translate3d(${thumbLeft}px, 0, 0)`;
      thumb.setAttribute('aria-valuenow', String(Math.round((scroller.scrollLeft / maxScroll) * 100)));
    };

    const onScroll = () => {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null;
        update();
      });
    };

    const scrollFromClientX = (clientX) => {
      const trackRect = scrollbar.getBoundingClientRect();
      const thumbWidth = thumb.offsetWidth;
      const maxThumb = Math.max(0, trackRect.width - thumbWidth);
      const offset = clientX - trackRect.left - thumbWidth / 2;
      const ratio = maxThumb > 0 ? Math.min(1, Math.max(0, offset / maxThumb)) : 0;
      scroller.scrollLeft = ratio * maxScrollOf();
    };

    const onPointerMove = (event) => {
      if (!dragging) return;
      const maxThumb = Math.max(0, scrollbar.clientWidth - thumb.offsetWidth);
      const delta = event.clientX - dragStartX;
      scroller.scrollLeft = dragStartScroll + (maxThumb > 0 ? (delta / maxThumb) * maxScrollOf() : 0);
    };

    const onPointerUp = () => {
      dragging = false;
      scroller.classList.remove('is-dragging');
      scrollbar.classList.remove('is-dragging');
      scrollbar.removeEventListener('pointermove', onPointerMove);
      scrollbar.removeEventListener('pointerup', onPointerUp);
      scrollbar.removeEventListener('pointercancel', onPointerUp);
    };

    const onPointerDown = (event) => {
      if (event.button !== 0) return;
      event.preventDefault();

      if (event.target !== thumb) scrollFromClientX(event.clientX);

      dragging = true;
      dragStartX = event.clientX;
      dragStartScroll = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      scrollbar.classList.add('is-dragging');
      scrollbar.setPointerCapture(event.pointerId);
      scrollbar.addEventListener('pointermove', onPointerMove);
      scrollbar.addEventListener('pointerup', onPointerUp);
      scrollbar.addEventListener('pointercancel', onPointerUp);
    };

    const onThumbKeydown = (event) => {
      const items = Array.from(scroller.querySelectorAll('.menswear-featured-collection__item'));
      if (!items.length) return;

      const scrollPos = scroller.scrollLeft;
      const viewWidth = scroller.clientWidth;

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        const next = items.find((item) => item.offsetLeft - scroller.offsetLeft > scrollPos + 10);
        if (next) {
          scroller.scrollTo({ left: next.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
        }
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        const prev = [...items].reverse().find((item) => item.offsetLeft - scroller.offsetLeft < scrollPos - 10);
        if (prev) {
          scroller.scrollTo({ left: prev.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
        } else {
          scroller.scrollTo({ left: 0, behavior: 'smooth' });
        }
      } else if (event.key === 'Home') {
        event.preventDefault();
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (event.key === 'End') {
        event.preventDefault();
        scroller.scrollTo({ left: scroller.scrollWidth - viewWidth, behavior: 'smooth' });
      }
    };

    scroller.addEventListener('scroll', onScroll, { passive: true });
    scrollbar.addEventListener('pointerdown', onPointerDown);
    thumb.addEventListener('keydown', onThumbKeydown);

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(scroller);
    if (scroller.firstElementChild) resizeObserver.observe(scroller.firstElementChild);

    update();
  }

  function initMenswearFeaturedScrollbars() {
    document.querySelectorAll('[data-mfc-scroller]').forEach(bindMenswearFeaturedScrollbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenswearFeaturedScrollbars);
  } else {
    initMenswearFeaturedScrollbars();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mfc-scroller]').forEach(bindMenswearFeaturedScrollbar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menswear-how-its-made"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('how-its-made-media')) {
    class HowItsMadeMedia extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-how-its-made-play]');
        this.sourcesNode = this.querySelector('[data-how-its-made-sources]');
        if (!this.button || !this.sourcesNode) return;

        this.onPlayClick = this.onPlayClick.bind(this);
        this.onMediaClick = this.onMediaClick.bind(this);
        this.onEnded = this.onEnded.bind(this);
        this.onPause = this.onPause.bind(this);

        this.button.addEventListener('click', this.onPlayClick);
        this.addEventListener('click', this.onMediaClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onPlayClick);
        this.removeEventListener('click', this.onMediaClick);
        if (this.video) {
          this.video.removeEventListener('ended', this.onEnded);
          this.video.removeEventListener('pause', this.onPause);
        }
      }

      onPlayClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.play();
      }

      onMediaClick() {
        if (this.classList.contains('is-playing') && this.video) {
          this.video.pause();
          return;
        }

        this.play();
      }

      onEnded() {
        this.showPoster();
      }

      onPause() {
        if (!this.video || this.video.ended) return;
        this.showPoster();
      }

      ensureVideo() {
        if (this.video) return this.video;

        let sources = [];
        try {
          sources = JSON.parse(this.sourcesNode.textContent);
        } catch (error) {
          return null;
        }

        if (!Array.isArray(sources) || sources.length === 0) return null;

        const video = document.createElement('video');
        video.className = 'menswear-how-its-made__video';
        video.controls = false;
        video.loop = false;
        video.preload = 'none';
        video.playsInline = true;
        video.setAttribute('playsinline', '');

        sources.forEach((source) => {
          if (!source || !source.url) return;
          const sourceEl = document.createElement('source');
          sourceEl.src = source.url;
          if (source.type) sourceEl.type = source.type;
          video.appendChild(sourceEl);
        });

        if (!video.querySelector('source')) return null;

        video.addEventListener('ended', this.onEnded);
        video.addEventListener('pause', this.onPause);
        this.insertBefore(video, this.firstChild);
        this.video = video;
        return video;
      }

      play() {
        const video = this.ensureVideo();
        if (!video) return;

        const playPromise = video.play();

        const markPlaying = () => {
          this.classList.add('is-playing');
          this.button.setAttribute('aria-hidden', 'true');
        };

        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(markPlaying).catch(() => {
            video.muted = true;
            video.play().then(markPlaying).catch(() => {});
          });
          return;
        }

        markPlaying();
      }

      showPoster() {
        this.classList.remove('is-playing');
        this.button.removeAttribute('aria-hidden');
      }
    }

    customElements.define('how-its-made-media', HowItsMadeMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menswear-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('menswear-testimonials')) {
    class MenswearTestimonials extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-testimonials-scroller]');
        this.track = this.querySelector('.menswear-testimonials__track');
        this.dots = Array.from(this.querySelectorAll('[data-testimonial-dot]'));
        this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]:not([data-clone])'));
        this.originalCount = this.slides.length;
        this.activeIndex = Number(this.dataset.featuredIndex || 0);
        this.activeSlide = null;
        this.ready = false;

        this.dragging = false;
        this.moved = false;
        this.ignoreScroll = false;
        this.dragStartX = 0;
        this.dragStartScroll = 0;
        this.scrollTimer = 0;

        this.onScroll = this.onScroll.bind(this);
        this.onScrollEnd = this.onScrollEnd.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onResize = this.onResize.bind(this);

        this.setupLoop();
        this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
        this.activeSlide = this.originalSlide(this.activeIndex) || this.slides[this.activeIndex] || null;

        if (this.scroller) {
          this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
          this.scroller.addEventListener('scrollend', this.onScrollEnd);
          this.scroller.addEventListener('pointerdown', this.onPointerDown);
          this.scroller.addEventListener('keydown', this.onKeydown);
        }

        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('resize', this.onResize);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.goTo(this.activeIndex, false, { closest: false });
            window.setTimeout(() => {
              this.ready = true;
            }, 120);
          });
        });
      }

      get canScroll() {
        return Boolean(this.scroller && this.scroller.scrollWidth > this.scroller.clientWidth + 2);
      }

      get prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      disconnectedCallback() {
        if (this.scroller) {
          this.scroller.removeEventListener('scroll', this.onScroll);
          this.scroller.removeEventListener('scrollend', this.onScrollEnd);
          this.scroller.removeEventListener('pointerdown', this.onPointerDown);
          this.scroller.removeEventListener('keydown', this.onKeydown);
          this.scroller.removeEventListener('pointermove', this.onPointerMove);
          this.scroller.removeEventListener('pointerup', this.onPointerUp);
          this.scroller.removeEventListener('pointercancel', this.onPointerUp);
        }

        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.onResize);
        window.clearTimeout(this.scrollTimer);
      }

      /* MARCA | 11 September 2026 | Clone the set on both sides, then teleport back to the real slides at wrap */
      setupLoop() {
        this.looping = this.originalCount > 1 && !window.Shopify?.designMode;

        if (!this.looping || !this.track) {
          this.classList.remove('is-looping');
          return;
        }

        this.classList.add('is-looping');
        if (this.track.hasAttribute('data-loop-ready')) return;

        const originals = Array.from(this.querySelectorAll('[data-testimonial-slide]:not([data-clone])'));
        const prepend = document.createDocumentFragment();
        const append = document.createDocumentFragment();

        originals.forEach((slide) => {
          prepend.appendChild(this.createClone(slide));
          append.appendChild(this.createClone(slide));
        });

        this.track.insertBefore(prepend, this.track.firstChild);
        this.track.appendChild(append);
        this.track.setAttribute('data-loop-ready', '');
      }

      createClone(slide) {
        const clone = slide.cloneNode(true);
        clone.classList.remove('is-active');
        clone.removeAttribute('aria-current');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-clone', '');

        Array.from(clone.attributes).forEach((attr) => {
          if (attr.name.startsWith('data-shopify')) clone.removeAttribute(attr.name);
        });

        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        clone.querySelectorAll('img').forEach((image) => {
          image.loading = 'lazy';
          image.fetchPriority = 'low';
        });

        return clone;
      }

      slideIndex(slide) {
        const fromData = Number(slide?.dataset.testimonialIndex);
        if (Number.isInteger(fromData)) return fromData;
        return this.slides.indexOf(slide);
      }

      originalSlide(realIndex) {
        return this.slides.find(
          (slide) => !slide.hasAttribute('data-clone') && this.slideIndex(slide) === realIndex
        );
      }

      closestSlide(realIndex) {
        if (!this.scroller) return this.originalSlide(realIndex);

        const scrollerRect = this.scroller.getBoundingClientRect();
        const center = scrollerRect.left + scrollerRect.width / 2;
        let best = null;
        let bestDistance = Infinity;

        this.slides.forEach((slide) => {
          if (this.slideIndex(slide) !== realIndex) return;
          const slideRect = slide.getBoundingClientRect();
          const distance = Math.abs(slideRect.left + slideRect.width / 2 - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = slide;
          }
        });

        return best || this.originalSlide(realIndex);
      }

      syncCenterPad() {
        if (!this.scroller || !this.slides.length) return;

        if (this.looping) {
          this.style.setProperty('--menswear-testimonials-center-pad', '0px');
          return;
        }

        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const pad = Math.max(0, (this.scroller.clientWidth - slideWidth) / 2);
        this.style.setProperty('--menswear-testimonials-center-pad', `${pad}px`);
      }

      wrapIndex(index) {
        const count = this.originalCount;
        if (!count) return 0;
        return ((index % count) + count) % count;
      }

      goTo(index, smooth = true, { closest = smooth } = {}) {
        if (!this.scroller || !this.originalCount) return;

        const realIndex = this.wrapIndex(index);
        const target =
          closest && this.looping ? this.closestSlide(realIndex) : this.originalSlide(realIndex) || this.closestSlide(realIndex);
        if (!target) return;

        this.setActiveFromSlide(target);
        this.syncCenterPad();
        this.ignoreScroll = true;
        requestAnimationFrame(() => {
          this.scrollToSlide(target, smooth);
          window.setTimeout(() => {
            this.ignoreScroll = false;
            if (target.hasAttribute('data-clone')) this.normalizeLoop(target);
          }, smooth && !this.prefersReducedMotion ? 420 : 80);
        });
      }

      setActiveFromSlide(slide) {
        if (!slide) return;

        const realIndex = this.slideIndex(slide);
        this.activeIndex = realIndex;
        this.activeSlide = slide;

        this.slides.forEach((item) => {
          const isVisualActive = item === slide;
          item.classList.toggle('is-active', isVisualActive);

          const isCurrent = !item.hasAttribute('data-clone') && this.slideIndex(item) === realIndex;
          if (isCurrent) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === realIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      centeredScrollLeft(slide) {
        const scrollerRect = this.scroller.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        return (
          this.scroller.scrollLeft +
          (slideRect.left + slideRect.width / 2) -
          (scrollerRect.left + scrollerRect.width / 2)
        );
      }

      scrollToSlide(slide, smooth) {
        if (!slide || !this.scroller) return;

        this.scroller.scrollTo({
          left: this.centeredScrollLeft(slide),
          behavior: smooth && !this.prefersReducedMotion ? 'smooth' : 'auto',
        });
      }

      nearestSlide() {
        if (!this.scroller || !this.slides.length) return null;

        const scrollerRect = this.scroller.getBoundingClientRect();
        const center = scrollerRect.left + scrollerRect.width / 2;
        let nearest = this.slides[0];
        let nearestDistance = Infinity;

        this.slides.forEach((slide) => {
          const slideRect = slide.getBoundingClientRect();
          const distance = Math.abs(slideRect.left + slideRect.width / 2 - center);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearest = slide;
          }
        });

        return nearest;
      }

      activateNearest() {
        const nearest = this.nearestSlide();
        if (nearest) this.setActiveFromSlide(nearest);
      }

      normalizeLoop(clone = this.nearestSlide()) {
        if (!this.looping || !this.scroller || !clone?.hasAttribute('data-clone')) return;

        const real = this.originalSlide(this.slideIndex(clone));
        if (!real) return;

        const offset = this.scroller.scrollLeft - this.centeredScrollLeft(clone);
        this.ignoreScroll = true;
        this.scroller.classList.add('is-dragging');
        this.scroller.scrollLeft = this.centeredScrollLeft(real) + offset;
        this.setActiveFromSlide(real);

        requestAnimationFrame(() => {
          this.scroller.classList.remove('is-dragging');
          this.ignoreScroll = false;
        });
      }

      settle(smooth = true) {
        if (!this.ready || !this.scroller || this.dragging || this.ignoreScroll) return;

        const nearest = this.nearestSlide();
        if (!nearest) return;

        this.setActiveFromSlide(nearest);

        if (this.looping && nearest.hasAttribute('data-clone')) {
          this.normalizeLoop(nearest);
          return;
        }

        if (Math.abs(this.scroller.scrollLeft - this.centeredScrollLeft(nearest)) > 2) {
          this.scrollToSlide(nearest, smooth);
        }
      }

      onScroll() {
        if (!this.ready || this.ignoreScroll || this.dragging) return;

        this.activateNearest();
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.settle(true), 320);
      }

      onScrollEnd() {
        if (!this.ready || this.ignoreScroll || this.dragging) return;
        window.clearTimeout(this.scrollTimer);
        this.settle(true);
      }

      onClick(event) {
        if (this.moved) {
          event.preventDefault();
          return;
        }

        const dot = event.target.closest('[data-testimonial-dot]');
        if (dot && this.contains(dot)) {
          this.goTo(Number(dot.dataset.testimonialDot));
          return;
        }

        const slide = event.target.closest('[data-testimonial-slide]');
        if (!slide || !this.contains(slide)) return;

        const index = this.slideIndex(slide);
        if (index !== this.activeIndex || slide.hasAttribute('data-clone')) this.goTo(index);
      }

      onKeydown(event) {
        if (!this.originalCount) return;

        let next = this.activeIndex;
        let closest = true;

        if (event.key === 'ArrowRight') {
          next = this.looping ? this.activeIndex + 1 : Math.min(this.activeIndex + 1, this.originalCount - 1);
        } else if (event.key === 'ArrowLeft') {
          next = this.looping ? this.activeIndex - 1 : Math.max(this.activeIndex - 1, 0);
        } else if (event.key === 'Home') {
          next = 0;
          closest = false;
        } else if (event.key === 'End') {
          next = this.originalCount - 1;
          closest = false;
        } else {
          return;
        }

        event.preventDefault();
        this.goTo(next, true, { closest });
      }

      onPointerDown(event) {
        if (!this.scroller || event.pointerType === 'touch' || event.button !== 0) return;
        if (!this.canScroll) return;
        if (event.target.closest('[data-testimonial-dot]')) return;

        this.dragging = true;
        this.moved = false;
        this.dragStartX = event.clientX;
        this.dragStartScroll = this.scroller.scrollLeft;
        this.scroller.classList.add('is-dragging');
        this.scroller.setPointerCapture(event.pointerId);
        this.scroller.addEventListener('pointermove', this.onPointerMove);
        this.scroller.addEventListener('pointerup', this.onPointerUp);
        this.scroller.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.dragging || !this.scroller) return;

        const delta = event.clientX - this.dragStartX;
        if (Math.abs(delta) > 4) this.moved = true;
        this.scroller.scrollLeft = this.dragStartScroll - delta;
        this.activateNearest();
      }

      onPointerUp() {
        if (!this.scroller) return;

        this.dragging = false;
        this.scroller.classList.remove('is-dragging');
        this.scroller.removeEventListener('pointermove', this.onPointerMove);
        this.scroller.removeEventListener('pointerup', this.onPointerUp);
        this.scroller.removeEventListener('pointercancel', this.onPointerUp);
        this.settle(true);

        window.setTimeout(() => {
          this.moved = false;
        }, 50);
      }

      onBlockSelect(event) {
        const slide = event.target.closest('[data-testimonial-slide]');
        if (!slide || !this.contains(slide) || slide.hasAttribute('data-clone')) return;
        this.goTo(this.slideIndex(slide), false, { closest: false });
      }

      onResize() {
        this.goTo(this.activeIndex, false, { closest: false });
      }
    }

    customElements.define('menswear-testimonials', MenswearTestimonials);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('support-cards')) {
    class SupportCards extends HTMLElement {
      connectedCallback() {
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-support-card]');
        if (!item || !this.contains(item)) return;

        this.querySelectorAll('[data-support-card]').forEach((card) => {
          card.classList.toggle('is-selected', card === item);
        });
      }

      onBlockDeselect(event) {
        const item = event.target.closest('[data-support-card]');
        if (!item || !this.contains(item)) return;
        item.classList.remove('is-selected');
      }
    }

    customElements.define('support-cards', SupportCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-accordions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('usp-accordions')) {
    class UspAccordions extends HTMLElement {
      connectedCallback() {
        this.teardown();

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.onHoverOver = this.onHoverOver.bind(this);
        this.onHoverMove = this.onHoverMove.bind(this);
        this.onHoverLeave = this.onHoverLeave.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onIntersection = this.onIntersection.bind(this);

        this.isVisible = false;
        this.pausedByHover = false;
        this.pausedByFocus = false;
        this.pausedByEditor = false;
        this.autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        this.autoplayInterval = Number(this.getAttribute('data-autoplay-interval')) || 10000;
        this.activateOnHover = this.getAttribute('data-activate-on-hover') === 'true';
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.desktopHoverQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (this.activateOnHover) {
          this.addEventListener('pointerover', this.onHoverOver);
          this.addEventListener('pointermove', this.onHoverMove);
          this.addEventListener('pointerleave', this.onHoverLeave);
        }

        if (!this.canAutoplay()) return;

        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onIntersection, { threshold: 0 });
          this.observer.observe(this);
        } else {
          this.isVisible = true;
          this.syncAutoplay();
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        this.clearAutoplay();
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (this.onKeydown) this.removeEventListener('keydown', this.onKeydown);
        if (this.onPointerEnter) this.removeEventListener('pointerenter', this.onPointerEnter);
        if (this.onPointerLeave) this.removeEventListener('pointerleave', this.onPointerLeave);
        if (this.onHoverOver) this.removeEventListener('pointerover', this.onHoverOver);
        if (this.onHoverMove) this.removeEventListener('pointermove', this.onHoverMove);
        if (this.onHoverLeave) this.removeEventListener('pointerleave', this.onHoverLeave);
        this.lastPointer = null;
        if (this.onFocusIn) this.removeEventListener('focusin', this.onFocusIn);
        if (this.onFocusOut) this.removeEventListener('focusout', this.onFocusOut);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        if (this.onVisibilityChange) document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      get items() {
        return Array.from(this.querySelectorAll('[data-usp-item]'));
      }

      canAutoplay() {
        return this.autoplayEnabled && this.autoplayInterval > 0 && this.items.length > 1 && !this.prefersReducedMotion;
      }

      canRunAutoplay() {
        return (
          this.canAutoplay() &&
          this.isVisible &&
          !this.pausedByHover &&
          !this.pausedByFocus &&
          !this.pausedByEditor &&
          document.visibilityState === 'visible'
        );
      }

      clearAutoplay() {
        if (!this.autoplayTimer) return;
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      syncAutoplay() {
        this.clearAutoplay();
        if (!this.canRunAutoplay()) return;

        this.autoplayTimer = setTimeout(() => {
          this.advance();
        }, this.autoplayInterval);
      }

      advance() {
        const items = this.items;
        if (items.length < 2) return;

        const current = items.findIndex((item) => item.classList.contains('is-active'));
        this.activate((Math.max(current, 0) + 1) % items.length);
      }

      activate(index) {
        if (index < 0) return;

        this.items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          const trigger = item.querySelector('[data-usp-trigger]');
          const panel = item.querySelector('[data-usp-panel]');

          item.classList.toggle('is-active', isActive);

          if (trigger) trigger.setAttribute('aria-expanded', String(isActive));
          if (panel) panel.inert = !isActive;
        });

        this.querySelectorAll('[data-usp-image]').forEach((image, imageIndex) => {
          const isActive = imageIndex === index;
          image.classList.toggle('is-active', isActive);
          image.setAttribute('aria-hidden', String(!isActive));
        });

        this.syncAutoplay();
      }

      onClick(event) {
        const trigger = event.target.closest('[data-usp-trigger]');
        if (!trigger || !this.contains(trigger)) return;

        const item = trigger.closest('[data-usp-item]');
        this.activate(this.items.indexOf(item));
      }

      usesHoverActivation() {
        return this.activateOnHover && this.desktopHoverQuery.matches;
      }

      // Opening a tab shifts the rows. Ignore that pointerover unless the cursor actually moved.
      pointerMoved(event) {
        if (!this.lastPointer) return true;
        const dx = event.clientX - this.lastPointer.x;
        const dy = event.clientY - this.lastPointer.y;
        return dx * dx + dy * dy >= 1;
      }

      activateFromTrigger(trigger) {
        const item = trigger.closest('[data-usp-item]');
        if (!item || item.classList.contains('is-active')) return;
        const index = this.items.indexOf(item);
        if (index < 0) return;
        this.activate(index);
      }

      onHoverOver(event) {
        if (!this.usesHoverActivation() || !this.pointerMoved(event)) return;

        this.lastPointer = { x: event.clientX, y: event.clientY };

        const trigger = event.target instanceof Element ? event.target.closest('[data-usp-trigger]') : null;
        if (!trigger || !this.contains(trigger)) return;
        if (event.relatedTarget instanceof Node && trigger.contains(event.relatedTarget)) return;

        this.activateFromTrigger(trigger);
      }

      onHoverMove(event) {
        if (!this.usesHoverActivation() || !this.pointerMoved(event)) return;

        this.lastPointer = { x: event.clientX, y: event.clientY };

        const trigger = event.target instanceof Element ? event.target.closest('[data-usp-trigger]') : null;
        if (!trigger || !this.contains(trigger)) return;

        this.activateFromTrigger(trigger);
      }

      onHoverLeave() {
        this.lastPointer = null;
      }

      onKeydown(event) {
        const trigger = event.target.closest('[data-usp-trigger]');
        if (!trigger || !this.contains(trigger)) return;

        const items = this.items;
        const current = items.indexOf(trigger.closest('[data-usp-item]'));
        let next = current;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          next = (current + 1) % items.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          next = (current - 1 + items.length) % items.length;
        } else if (event.key === 'Home') {
          event.preventDefault();
          next = 0;
        } else if (event.key === 'End') {
          event.preventDefault();
          next = items.length - 1;
        } else {
          return;
        }

        const nextTrigger = items[next].querySelector('[data-usp-trigger]');
        if (nextTrigger) nextTrigger.focus();
        this.activate(next);
      }

      onPointerEnter() {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        this.pausedByHover = true;
        this.clearAutoplay();
      }

      onPointerLeave() {
        this.pausedByHover = false;
        this.syncAutoplay();
      }

      onFocusIn(event) {
        if (!(event.target instanceof Element)) return;
        if (!event.target.closest('[data-usp-trigger]')) return;
        if (!event.target.matches(':focus-visible')) return;
        this.pausedByFocus = true;
        this.clearAutoplay();
      }

      onFocusOut(event) {
        if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
        this.pausedByFocus = false;
        this.syncAutoplay();
      }

      onVisibilityChange() {
        this.syncAutoplay();
      }

      onIntersection(entries) {
        this.isVisible = entries.some((entry) => entry.isIntersecting);
        this.syncAutoplay();
      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-usp-item]');
        if (!item || !this.contains(item)) return;
        this.pausedByEditor = true;
        this.activate(this.items.indexOf(item));
      }

      onBlockDeselect(event) {
        const item = event.target.closest('[data-usp-item]');
        if (!item || !this.contains(item)) return;
        this.pausedByEditor = false;
        this.syncAutoplay();
      }
    }

    customElements.define('usp-accordions', UspAccordions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('usp-cards')) {
    class UspCards extends HTMLElement {
      connectedCallback() {
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-usp-card]');
        if (!item || !this.contains(item)) return;

        this.querySelectorAll('[data-usp-card]').forEach((card) => {
          card.classList.toggle('is-selected', card === item);
        });
      }

      onBlockDeselect(event) {
        const item = event.target.closest('[data-usp-card]');
        if (!item || !this.contains(item)) return;
        item.classList.remove('is-selected');
      }
    }

    customElements.define('usp-cards', UspCards);
  }

  } catch(e) { console.error(e); }
})();
})();
